import { c as _c } from "react/compiler-runtime";
const SiteCover = t0 => {
  const $ = _c(3);
  const {
    close,
    coverVisible,
    transparent: t1
  } = t0;
  const transparent = t1 === undefined ? false : t1;
  const t2 = `fixed z-30 transition-opacity duration-300 ease-in-out ${transparent ? "bg-transparent" : "bg-gray-10"} w-full h-full left-0 right-0 top-0 bottom-0 ${coverVisible ? "visible" : "invisible pointer-events-none"}`;
  let t3;
  if ($[0] !== close || $[1] !== t2) {
    t3 = <div onClick={close} aria-hidden="true" className={t2} />;
    $[0] = close;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default SiteCover;